// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_2lmRlUCBHOKPQzQ-i7xeZp"};